import React, { createContext, useContext } from 'react';

interface FeatureFlagContextValue {
  isConfigured: boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  isConfigured: false,
});

export const useFeatureFlagContext = () => useContext(FeatureFlagContext);

interface FeatureFlagContextProviderProps {
  isConfigured: boolean;
  children: React.ReactNode;
}

export const FeatureFlagContextProvider: React.FC<FeatureFlagContextProviderProps> = ({
  isConfigured,
  children,
}) => (
  <FeatureFlagContext.Provider value={{ isConfigured }}>
    {children}
  </FeatureFlagContext.Provider>
);
